import { render } from "./ListIcon.vue?vue&type=template&id=5145c457"
import script from "./ListIcon.vue?vue&type=script&lang=js"
export * from "./ListIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__